import get from 'lodash/get'

export const hasDependencies = supplier => !!['contacts', 'lands', 'notes'].find(dependency => get(supplier, `${dependency}.length`, 0) > 0)
